interface BuildConferenceSectionYearStateParams<T> {
  availableYears?: number[];
  defaultYear?: number;
  defaultData?: T;
}

export interface ConferenceSectionYearState<T> {
  availableYears: number[];
  defaultYear?: number;
  defaultData?: T;
}

const isValidYear = (value?: number): value is number =>
  typeof value === 'number' && Number.isFinite(value);

const toUniqueYears = (years?: number[]) =>
  (years || [])
    .filter(isValidYear)
    .filter((year, index, list) => list.indexOf(year) === index);

export const buildConferenceSectionYearState = <T>({
  availableYears = [],
  defaultYear,
  defaultData,
}: BuildConferenceSectionYearStateParams<T>): ConferenceSectionYearState<T> => {
  const normalizedYears = toUniqueYears(availableYears);
  const resolvedDefaultYear =
    isValidYear(defaultYear) && normalizedYears.includes(defaultYear)
      ? defaultYear
      : normalizedYears[0];

  return {
    availableYears: normalizedYears,
    defaultYear: resolvedDefaultYear,
    defaultData: isValidYear(resolvedDefaultYear) ? defaultData : undefined,
  };
};

export const isConferenceSectionYearStateVisible = <T>(
  state?: ConferenceSectionYearState<T>
) => Boolean(state?.availableYears.length && isValidYear(state.defaultYear));
